import { DatePipe, Time } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormsModule, NgForm } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ConfirmationModalComponent } from "src/app/shared/components/confirmation-modal/confirmation-modal.component";
import { DowntimeConfirmationModalComponent } from "../downtime-confirmation-modal/downtime-confirmation-modal.component";
import { AdminPortalService } from "../../service/admin-portal.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-downtime-modal",
  templateUrl: "./downtime-modal.component.html",
  styleUrls: ["./downtime-modal.component.css"],
  providers: [DatePipe],
})
export class DowntimeModalComponent implements OnInit {
  //  @ViewChild("startDateRef") startCalendar: any;

  startMaintenance: boolean;
  endMaintenance: boolean;
  date = new FormControl({ value: new Date(Date.now()), disabled: false });
  startDate!: Date | null;
  startTime!: string | null;
  endDate!: Date | null;
  endTime!: string | null;
  submitForm: boolean;
  minDate: Date;
  minTime: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DowntimeModalComponent>,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private adminService: AdminPortalService,
    private toastr: ToastrService
  ) {
    this.startMaintenance = true;
    this.endMaintenance = false;
    this.submitForm = false;
    this.minDate = new Date(Date.now());
    // this.minTime = `${this.minDate.getHours()}:${this.minDate.getMinutes()}`;
    this.minTime = ``;
  }

  ngOnInit(): void {}

  onSubmit() {
    this.submitForm = true;

    //check if all form details are correctly provided
    if (
      !(
        (this.startMaintenance ||
          (this.startDate != null && this.startTime != null)) &&
        (!this.endMaintenance || (this.endDate != null && this.endTime != null))
      )
    ) {
      return;
    }

    const finalStartDateTime = this.startMaintenance? this.formatDateTime(
      new Date(Date.now()),
      `${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`
    ): this.formatDateTime(
      this.startDate as Date,
      this.startTime as string
    );
    const finalEndDateTime = this.endMaintenance
      ? this.formatDateTime(
          this.endDate as Date,
          this.endTime as string
        )
      : null;
    // api call
    this.adminService
      .sendRedemptionDowntimeData(finalStartDateTime, finalEndDateTime)
      .subscribe({ next: (data) => {
        this.dialogRef.close({status: true});
    
        // success modal
        let dataDialog = {
          title: "Redemption paused successfully.",
          img: "../../../../assets/images/redemption-pause-icon.svg",
          scheduleDowntime: !this.startMaintenance,
          startDate: this.datePipe.transform(this.startDate, "dd/MM/yyyy"),
          startTime: this.startTime,
          confirmButton: false,
        };
        if (!this.startMaintenance) {
          dataDialog.title = "Downtime has been scheduled for";
        }
        const dialogRef = this.dialog.open(DowntimeConfirmationModalComponent, {
          width: "513px",
          data: dataDialog,
        });
      }, error: (e) => {this.toastr.error(e.error);} });
  }

  validateStartDate(control: any, endDateControl: any){
    if(!control) return;
    if(this.startMaintenance || !this.startDate || !this.startTime) return;

    const startDateTime = this.startMaintenance? new Date(Date.now()): this.combineDateTime(this.startDate, this.startTime);

    if ((new Date().getTime() - new Date(startDateTime).getTime()) > 60000) {
      control.control.setErrors({ startDateTime: 'Start date cannot be in the past' });
    }else{
      const errors = control.control.errors;
      if (errors) {
        this.removeValidation(control, 'startDateTime')
      }
    }
    if(this.endMaintenance){
      this.validateEndDate(endDateControl);
    }
  }

  combineDateTime(date: Date, time: string): Date {
    const [hours, minutes] = time.split(":").map(Number);
    const combined = new Date(date);
    combined.setHours(hours, minutes, 0, 0);
    return combined;
  }

  formatDateTime(startDate: Date, startTime: string): string {
    // Combine date and time into one string
    const [hours, minutes, seconds = '00'] = startTime.split(':');
    
    const combinedDate = new Date(startDate);
    combinedDate.setHours(Number(hours), Number(minutes), Number(seconds), 0); // milliseconds set to 0
  
    // Format to "yyyy-MM-dd HH:mm:ss.SSS"
    const yyyy = combinedDate.getFullYear();
    const MM = String(combinedDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(combinedDate.getDate()).padStart(2, '0');
    const HH = String(combinedDate.getHours()).padStart(2, '0');
    const mm = String(combinedDate.getMinutes()).padStart(2, '0');
    const ss = String(combinedDate.getSeconds()).padStart(2, '0');
    const SSS = String(combinedDate.getMilliseconds()).padStart(3, '0');
  
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}.${SSS}`;
  }

  validateEndDate(control: any) {
    if (!control) return;
    if(!this.startMaintenance && (!this.startDate || !this.startTime)) {
      this.removeValidation(control, 'endBeforeStart')
      return;
    }
    if(!this.endDate || !this.endTime) return;

    const startDateTime = this.startMaintenance? new Date(Date.now()): this.combineDateTime(this.startDate!, this.startTime!);
    const endDateTime = this.combineDateTime(this.endDate, this.endTime);
  
    if (endDateTime <= startDateTime) {
      control.control.setErrors({ endBeforeStart: 'End date cannot be same or before start date' });
    } else {
      this.removeValidation(control, 'endBeforeStart')
    }
  }

  removeValidation(control: any, validation: string){
    const errors = control.control.errors;
    if (errors) {
      delete errors[validation];
      if (Object.keys(errors).length === 0) {
        control.control.setErrors(null);
      } else {
        control.control.setErrors(errors);
      }
    }
  }
  
  


  onCancel() {
    this.dialogRef.close({status: false});
  }
}
